module.exports = __webpack_public_path__ + "static/media/export-marketing-data.2681effb.png";